import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 58rem;
  width: min(86.3rem, 90%);
`;

interface IMainButton {
  disabled?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.disabled ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
`}

  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  justify-content: center;
  min-height: 5.6rem;
  width: 30rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
  }
`;

export const StepContainer = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.black};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .back-button {
    align-self: flex-start;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    margin-left: 4.4rem;
    margin-top: 5.5rem;
  }

  .logo {
    margin: 1rem 0 1rem 3rem;
  }

  .error-message {
    color: ${(props) => props.theme.colors.accentRed};
    font-size: 1.2rem;
    line-height: 2rem;
    margin-top: 1.9rem;
    text-align: center;
    width: 25.6rem;
  }
`;

export const NewPasswordStep = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  .input-password-confirm {
    margin-bottom: 3rem;
  }
`;

export const EmailStep = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  .input-email {
    margin: 3rem 0 6rem 0;
    width: 30rem;
  }

  .info-message {
    color: ${(props) => props.theme.colors.gray72};
    font-size: 1.4rem;
    margin: 2.8rem 0;
    text-align: center;
    width: 30rem;
  }
`;
